import { getDeviceID } from "@/lib/device-id"

export const userLoginV1 = async (phoneNo: string) => {
  const res = await fetch(`/api/auth/v1/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone_no: phoneNo }),
  })
  return res.json()
}

export const verifyPinV1 = async (phoneNo: string, pin: string) => {
  const res = await fetch(`/api/auth/v1/login/pin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone_no: phoneNo, pin, device_id: getDeviceID() }),
  })
  return res.json()
}

export const verifyOtpV1 = async (phoneNo: string, otp: string) => {
  const res = await fetch(`/api/auth/v1/login/otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone_no: phoneNo, otp, device_id: getDeviceID() }),
  })
  return res.json()
}

export const resendOtpV1 = async (phoneNo: string) => {
  const res = await fetch(`/api/auth/v1/login/otp/resend`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone_no: phoneNo, device_id: getDeviceID() }),
  })
  return res.json()
}
